import { Modal, Button } from "react-bootstrap";

const ModalDeleteRep = ({ show, handleClose, data, onDeleteChange }) => {
  const handleSubmit = () => {
    onDeleteChange(data); // Update ke parent
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="sm"
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Delete Recepient</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete this data:{" "}
        <b>{Array.isArray(data) ? "Selected Contact" : data.name}</b>?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleSubmit}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDeleteRep;
